import { Box, styled } from "@mui/material";

export const BoxWrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
    gap: "16px",
  },
  display: "grid",
  rowGap: "16px",
}));